import React from 'react'
import { v4 } from 'uuid'

import * as Styled from './styled'
import { Props } from './types'

const SimpleTable: React.FunctionComponent<Props> = ({
  header,
  items,
  icon,
  className,
  idLabel,
}) => {
  const Icon = icon
  return (
    <section className={className}>
      <h2>{header}</h2>
      <table>
        <tbody>
          {items.map((item, i) => (
            <Styled.TR key={v4()}>
              <Styled.TD className="left">
                <Icon title={`${idLabel}-${i}`} />
                <div> {item.label}</div>
              </Styled.TD>
              <Styled.TD className="right">{item.value}</Styled.TD>
            </Styled.TR>
          ))}
        </tbody>
      </table>
    </section>
  )
}

export default SimpleTable
